export default __webpack_public_path__ + "c4fcf4663cd66468cb30adeef68299bd.svg";